
import BDWidget from '../Widget'
import decrease from '../../icons/decrease'
import increase from '../../icons/increase'
import refresh from '../../icons/refresh'
import DomUtil from '../../utils/DomUtil'
class ZoomController extends BDWidget {


    constructor() {
        super();
    }

    getType() {
        return "zoomController"
    }

    mountContent() {
        this._wrapper = DomUtil.create('div', 'bd-zoom-controller');

        this._zoomInEl = DomUtil.parseDom(increase, true, 'zoom-in')
        this._refreshEl = DomUtil.parseDom(refresh, true, 'refresh')
        this._zoomOutEl = DomUtil.parseDom(decrease, true, 'zoom-out')
        this._wrapper.appendChild(this._zoomInEl)
        this._wrapper.appendChild(this._refreshEl)
        this._wrapper.appendChild(this._zoomOutEl)
        this.hide();
    }

    bindEvent() {
        var self = this;
        this._zoomInEl.onclick = () => {
            self._zoomIn()
        }
        this._refreshEl.onclick = () => {
            self._refresh()
        }
        this._zoomOutEl.onclick = () => {
            self._zoomOut()
        }
        this.viewer.container.appendChild(this._wrapper);
        this.show();
    }

    unbindEvent() {
        this.viewer.container.removeChild(this._wrapper);
        this.hide();
    }

    /**
    *
    * @param scene
    * @returns {Cartesian3}
    * @private
    */
    _getCameraFocus(scene) {
        const ray = new Cesium.Ray(
            scene.camera.positionWC,
            scene.camera.directionWC
        )
        const intersections = Cesium.IntersectionTests.rayEllipsoid(
            ray,
            Cesium.Ellipsoid.WGS84
        )
        if (intersections) {
            return Cesium.Ray.getPoint(ray, intersections.start)
        }
        // Camera direction is not pointing at the globe, so use the ellipsoid horizon point as
        // the focal point.
        return Cesium.IntersectionTests.grazingAltitudeLocation(
            ray,
            Cesium.Ellipsoid.WGS84
        )
    }

    /**
    *
    * @param camera
    * @param focus
    * @param scalar
    * @returns {Cartesian3}
    * @private
    */
    _getCameraPosition(camera, focus, scalar) {
        const cartesian3Scratch = new Cesium.Cartesian3()
        let direction = Cesium.Cartesian3.subtract(
            focus,
            camera.position,
            cartesian3Scratch
        )
        let movementVector = Cesium.Cartesian3.multiplyByScalar(
            direction,
            scalar,
            cartesian3Scratch
        )
        return Cesium.Cartesian3.add(
            camera.position,
            movementVector,
            cartesian3Scratch
        )
    }

    /**
    *
    * @returns {boolean}
    * @private
    */
    _zoomIn() {
        let scene = this.viewer.scene
        let camera = scene.camera
        let sscc = scene.screenSpaceCameraController
        if (
            scene.mode === Cesium.SceneMode.MORPHING ||
            !sscc.enableInputs ||
            scene.mode === Cesium.SceneMode.COLUMBUS_VIEW
        ) {
            return true
        } else if (scene.mode === Cesium.SceneMode.SCENE2D) {
            camera.zoomIn(camera.positionCartographic.height * 0.5)
        } else if (scene.mode === Cesium.SceneMode.SCENE3D) {
            let focus = this._getCameraFocus(scene)
            let cameraPosition = this._getCameraPosition(camera, focus, 1 / 2)
            camera.flyTo({
                destination: cameraPosition,
                orientation: {
                    heading: camera.heading,
                    pitch: camera.pitch,
                    roll: camera.roll
                },
                duration: 0.5,
                convert: false
            })
        }
    }

    /**
    *
    * @returns {boolean}
    * @private
    */
    _zoomOut() {
        let scene = this.viewer.scene
        let camera = scene.camera
        let sscc = scene.screenSpaceCameraController
        if (
            scene.mode === Cesium.SceneMode.MORPHING ||
            !sscc.enableInputs ||
            scene.mode === Cesium.SceneMode.COLUMBUS_VIEW
        ) {
            return true
        } else if (scene.mode === Cesium.SceneMode.SCENE2D) {
            camera.zoomOut(camera.positionCartographic.height)
        } else if (scene.mode === Cesium.SceneMode.SCENE3D) {
            let focus = this._getCameraFocus(scene)
            let cameraPosition = this._getCameraPosition(camera, focus, -1)
            camera.flyTo({
                destination: cameraPosition,
                orientation: {
                    heading: camera.heading,
                    pitch: camera.pitch,
                    roll: camera.roll
                },
                duration: 0.5,
                convert: false
            })
        }
    }
    /**
     *
     * @private
     */
    _refresh() {
        if (Cesium.zhiPos) {
            viewer.camera.flyTo({
                destination: Cesium.zhiPos,
            });

            return;
        }
        this.viewer.camera.flyHome(1.5)
    }


}


export default ZoomController